import { ChangeDetectionStrategy, Component, input, OnInit, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { LoanTeamMember } from '@ld.consumer-portal/models';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

export interface RequestCallbackEvent {
  agentId: string;
  agentName: string;
}

@Component({
  selector: 'ld-request-callback-modal',
  imports: [BaseModalComponent, MatIconModule, MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './request-callback-modal.component.html',
  styleUrl: './request-callback-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestCallbackModalComponent implements OnInit {
  readonly agents = input.required<LoanTeamMember[]>();

  readonly isLoading = input<boolean>(false);

  readonly confirm = output<RequestCallbackEvent>();

  readonly cancel = output<void>();

  protected readonly selectedAgent = signal<LoanTeamMember | null>(null);

  ngOnInit(): void {
    const agents = this.agents();
    if (agents.length > 0) {
      this.selectedAgent.set(agents[0]);
    }
  }

  protected selectAgent(agent: LoanTeamMember): void {
    this.selectedAgent.set(agent);
  }

  protected onConfirm(): void {
    const agent = this.selectedAgent();
    if (!this.isLoading() && agent) {
      this.confirm.emit({
        agentId: agent.id,
        agentName: agent.name,
      });
    }
  }

  protected onCancel(): void {
    if (!this.isLoading()) {
      this.cancel.emit();
    }
  }

  protected getInitials(name: string): string {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }
}
